import { useMutation, useQueryClient } from 'react-query';

import { singVisitByPestEmployeePost as sing } from 'api/visitReports/signVisitByPestEmployee';

const useSignVisitByEmployee = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: singVisitByEmployee,
    isLoading,
  } = useMutation(sing, {
    onSuccess: () => {
      queryClient.invalidateQueries('visitDocs');
    },
  });

  return {
    isSuccess,
    singVisitByEmployee,
    isLoading,
  };
};

export default useSignVisitByEmployee;
